import { render } from "./PartnerItemsSection.vue?vue&type=template&id=83b2e02e"
import script from "./PartnerItemsSection.vue?vue&type=script&lang=js"
export * from "./PartnerItemsSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__